import React, { useMemo } from 'react';
import { Avatar } from 'design-system/avatar';
import { CIRCLE_BORDER_SIZE, CIRCLE_SIZE } from 'design-system/LogoBankAccount';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { selectUserId } from 'reducers/selectors';
import { IconTrash } from 'design-system/icons';
import { Indicator, SettingsItem, SettingsItemRightContent, } from 'design-system';
import Text from 'design-system/Text';
import Modal from 'utils/packages/Modal';
import TouchableOpacity from 'utils/packages/TouchableOpacity';
import { useDeleteSpaceMember } from '../hooks';
import EditSpaceItem from '../components/EditSpaceItem';
import { isWeb } from '../../../constants';
const SpaceMemberItem = ({ spaceId, ownerId, member, disabled, onRemoved, }) => {
    const { id, handle, firstName, lastName, imageUrl } = member;
    const myId = useAppSelector(selectUserId);
    const [removable, name, desc, firstLetter, lastLetter] = useMemo(() => {
        if (id === myId)
            return [
                ownerId !== myId && !disabled,
                firstName && lastName
                    ? `${firstName} ${lastName}`
                    : firstName ?? lastName ?? handle,
                `@${handle}`,
                firstName ?? '?',
                lastName ?? '',
            ];
        return [
            ownerId === myId && !disabled,
            firstName && lastName
                ? `${firstName} ${lastName}`
                : firstName ?? lastName ?? handle,
            `@${handle}`,
            firstName ?? '?',
            lastName ?? '',
        ];
    }, [id, myId, ownerId, disabled, firstName, lastName, handle]);
    const [remove, removeBusy] = useDeleteSpaceMember(spaceId, () => {
        onRemoved?.();
    });
    const onRemove = () => {
        if (!removeBusy) {
            const titleText = myId === member.id ? 'Are you sure?' : `Remove ${firstName}?`;
            const removeText = myId === member.id
                ? 'You will lose access to this space. Any accounts you added here will be moved to your Private space.'
                : 'They will lose access to this space. Any accounts they added here will be moved to their Private space.';
            const deleteBtnText = myId === member.id
                ? 'Yes, I want to leave this space'
                : 'Yes, let me remove';
            Modal.showConfirmation({
                title: titleText,
                subtitle: removeText,
                confirmButtonTitle: 'No, thanks',
                cancelButtonTitle: deleteBtnText,
                onPressCancel: () => remove(id),
            });
        }
    };
    const colors = useColors();
    const leftIcon = (<Avatar name={firstLetter} lastName={lastLetter} size={rem(CIRCLE_SIZE)} color={colors.background.brandLight} fontColor={colors.text.textOnBrand} imageUrl={imageUrl} borderWidth={CIRCLE_BORDER_SIZE} style={!isWeb && { marginRight: rem(16) }} medium/>);
    if (isWeb) {
        return removable ? (<EditSpaceItem title={name} subTitle={desc} leftIcon={leftIcon} rightIcon={removeBusy ? (<Indicator dark/>) : (<IconTrash color={colors.elements.secondary}/>)} onPressRight={removeBusy || disabled ? undefined : onRemove}/>) : (<EditSpaceItem title={name} subTitle={desc} leftIcon={leftIcon} rightIcon={!removable &&
                ownerId === member.id && (<Text Text-12 Gray-50>
              Owner
            </Text>)}/>);
    }
    return (<SettingsItem renderIcon={() => leftIcon} title={name} description={desc}>
      <SettingsItemRightContent>
        {!removable && ownerId === member.id && (<Text Text-14 Gray-50>
            Owner
          </Text>)}

        {removeBusy ? <Indicator dark/> : null}

        {!removeBusy && removable ? (<TouchableOpacity hoverOnDark onPress={removeBusy || disabled ? undefined : onRemove} testID="invite-cancel-button">
            <IconTrash gradientColors={[
                colors.elements.secondary,
                colors.elements.secondary,
            ]}/>
          </TouchableOpacity>) : null}
      </SettingsItemRightContent>
    </SettingsItem>);
};
export default SpaceMemberItem;
